import React from 'react'
import NavBar from '../Header/NavBar'
import { Outlet } from 'react-router-dom'
import Footer from '../Footer/Footer'

export default function Layout() {
  return (
    <div>
      
      <NavBar/>
      <Outlet/>
      <Footer/>

    </div>
  )
}
